//@flow
import { BaseManager } from "../base";
import { RequestTypes } from "../request-type/RequestType";
import type { BaseManagerResponse } from "../base/BaseManagerResponse";
import ServiceError from "../error/ServiceError";

export default class NotificationsManager extends BaseManager {
  async getUnreadNotificationsCount(
    dataSetId: string,
    category: string,
    entityId: string,
    lastVisitUnixTimestamp: ?number,
  ): BaseManagerResponse {
    let url = `${dataSetId}/categories/${category}/entities/${entityId}/notifications/${lastVisitUnixTimestamp || 0}/`;
    let response: BaseManagerResponse = await this.fetchJSON(RequestTypes.GET, url);
    if (response instanceof ServiceError) {
      return response;
    }
    return response;
  }
}
